import styled from 'styled-components'

export const RadioContainer = styled.div`
  & + & {
    margin-top: var(--space-400);
  }
`
